"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Base = _interopRequireDefault(require("./Base"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _Options = _interopRequireDefault(require("../Dropdown/Options"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SearchDropdown =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchDropdown, _PureComponent);

  function SearchDropdown(props) {
    var _this;

    _classCallCheck(this, SearchDropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchDropdown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "clear", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');
      var options = _this.props.options;
      var visible = _this.state.visible;

      if ((0, _lib.arrayHasItems)(options)) {
        visible = true;
      }

      _this.setState({
        value: '',
        selected: null,
        visible: visible
      }, function () {
        var onClear = _this.props.onClear;

        if (onClear) {
          onClear(e);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSelect", function (e, selected) {
      (0, _lib.callEventMethods)(e, 'persist');
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      var value = selected.value;

      _this.setState({
        value: value,
        selected: selected,
        visible: false
      }, function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          onChange(e, _objectSpread({
            name: name
          }, selected));
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToggle", function (e) {
      var _this$state = _this.state,
          value = _this$state.value,
          visible = _this$state.visible;
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (value) {
        if (!visible) {
          _this.handleOnOpen(e);
        } else {
          _this.handleOnClose(e);
        }
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');
      var visible = _this.state.visible;

      if (visible) {
        if (!e.target.classList.contains(_Options["default"].Item.className)) {
          // if click on dropdown item, wont close, otherwise close
          _this.handleOnClose(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isItemSelected", function (value) {
      var selected = _this.state.selected;

      if (selected) {
        return value === selected.value;
      }

      return false;
    });

    var _value = props.value,
        defaultValue = props.defaultValue,
        _visible = props.visible,
        _options = props.options;
    var newVisible = (0, _lib.arrayHasItems)(_options) ? true : _visible;
    _this.state = {
      prevProps: {
        value: _value,
        visible: _visible,
        options: _options
      },
      // this only store props.value
      value: _value || defaultValue,
      visible: newVisible,
      selected: null
    };
    _this.innerRef = _react["default"].createRef();
    return _this;
  }

  _createClass(SearchDropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var visible = this.state.visible;

      if (visible !== prevState.visible) {
        if (visible) {
          document.addEventListener('click', this.handleCheckClose);
        } else {
          document.removeEventListener('click', this.handleCheckClose);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          visible = _this$props3.visible,
          options = _this$props3.options,
          disabled = _this$props3.disabled,
          onChange = _this$props3.onChange,
          onClear = _this$props3.onClear,
          onClick = _this$props3.onClick,
          loading = _this$props3.loading,
          loaderNode = _this$props3.loaderNode,
          itemNode = _this$props3.itemNode,
          emptyNode = _this$props3.emptyNode,
          withPortal = _this$props3.withPortal,
          direction = _this$props3.direction,
          rest = _objectWithoutProperties(_this$props3, ["visible", "options", "disabled", "onChange", "onClear", "onClick", "loading", "loaderNode", "itemNode", "emptyNode", "withPortal", "direction"]);

      var _this$state2 = this.state,
          value = _this$state2.value,
          selected = _this$state2.selected;
      var showOptions = !!value && !loading && this.state.visible;
      return _react["default"].createElement(_Base["default"], _extends({}, rest, {
        wrapperRef: this.innerRef,
        value: value,
        loading: loading,
        disabled: disabled,
        attached: showOptions ? 'bottom' : null,
        onClick: this.handleOnToggle,
        onChange: this.handleOnChange,
        onClear: this.clear,
        readOnly: !!selected
      }), _react["default"].createElement(_Options["default"], {
        parent: this.innerRef.current,
        withPortal: withPortal,
        direction: direction,
        visible: showOptions,
        options: options,
        disabled: disabled,
        onChange: this.handleOnSelect,
        isItemSelected: this.isItemSelected,
        emptyNode: emptyNode
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          visible = props.visible,
          options = props.options;
      var selected = props.selected;
      var newVisible = !selected ? true : visible;
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          visible: visible,
          options: options
        },
        value: prevProps.value !== value ? value : state.value,
        visible: prevProps.visible !== visible || prevProps.options !== options ? newVisible : state.visible
      };
    }
  }]);

  return SearchDropdown;
}(_react.PureComponent);

exports["default"] = SearchDropdown;

_defineProperty(SearchDropdown, "displayName", 'SearchDropdown');

_defineProperty(SearchDropdown, "propTypes", {
  name: _propTypes["default"].string,
  value: _common.customPropTypes.stringOrNumber,
  defaultValue: _common.customPropTypes.stringOrNumber,
  options: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_common.customPropTypes.stringOrNumber, _propTypes["default"].shape({
    value: _common.customPropTypes.stringOrNumber.isRequired,
    label: _propTypes["default"].string,
    name: _propTypes["default"].string,
    text: _propTypes["default"].string,
    title: _propTypes["default"].string,
    disabled: _propTypes["default"].bool
  })])),
  loading: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  visible: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onClear: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  loaderNode: _propTypes["default"].node,
  itemNode: _propTypes["default"].func,
  emptyNode: _propTypes["default"].node,
  withPortal: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['auto'])), _propTypes["default"].arrayOf(_propTypes["default"].oneOf([].concat(_toConsumableArray(_constants.DIRECTION_ALL), ['autoV', 'autoH'])))])
});

_defineProperty(SearchDropdown, "defaultProps", {
  name: null,
  value: undefined,
  defaultValue: '',
  options: [],
  loading: false,
  disabled: false,
  visible: false,
  onChange: null,
  onClear: null,
  onClick: null,
  loaderNode: null,
  itemNode: null,
  emptyNode: _react["default"].createElement(_Dropdown["default"].Item, null, "No result found."),
  withPortal: false,
  direction: 'auto'
});